import { Controller } from '@hotwired/stimulus';
import confetti from 'canvas-confetti';

export default class extends Controller {
  static values = {
    scrollTo: String,
  };

  connect() {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });

    if (this.scrollToValue !== undefined) {
      const element = document.querySelector(this.scrollToValue);
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
